import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext.js'

// featureMustBeOn: requiredFeature must be explicitly true, not just "not false" — for
// features that are off by default (see the matching comment in Sidebar.jsx).
const ProtectedRoute = ({ children, ownerOnly = false, adminOnly = false, requiredFeature = null, featureMustBeOn = false }) => {
  const { account, admin, loading, authError, retryLogin, isOwner, isUser, features } = useAuth()

  // Still loading (MSAL init / profile fetch / login popup in progress)
  if (loading) {
    return (
      <div className="loading-state loading-state--full">
        <span className="spinner" />
        <span>Anmelden…</span>
      </div>
    )
  }

  // Login failed — popup was blocked, user cancelled, or account is not in admin_users
  if (authError) {
    return (
      <div className="loading-state loading-state--full" style={{ flexDirection: 'column', gap: 16 }}>
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', maxWidth: 360 }}>{authError}</p>
        <button className="btn btn-primary" onClick={retryLogin}>
          Mit Microsoft anmelden
        </button>
      </div>
    )
  }

  // Should not happen (Option B always keeps a user logged in), but guard anyway
  if (!account || !admin) return null

  // Role / feature guards
  if (ownerOnly && !isOwner) return <Navigate to="/" replace />
  if (adminOnly && isUser) return <Navigate to="/" replace />
  if (requiredFeature && !isOwner && features[requiredFeature] === false) return <Navigate to="/" replace />
  if (requiredFeature && featureMustBeOn && !isOwner && features[requiredFeature] !== true) return <Navigate to="/" replace />

  return children
}

export default ProtectedRoute
